export const locale = {
    lang: 'en',
    data: {
        NAVIGATION_BOARDS: 'Boards',
        NAVIGATION_SESSIONS: 'Workshops',
        NAVIGATION_DOCUMENTS: 'Documents',
        NAVIGATION_DETAILS: 'About',
    }
};
